/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactSiegeDoublonGridDto } from './ContactSiegeDoublonGridDto';
import {
    ContactSiegeDoublonGridDtoFromJSON,
    ContactSiegeDoublonGridDtoFromJSONTyped,
    ContactSiegeDoublonGridDtoToJSON,
} from './ContactSiegeDoublonGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContactSiegeDoublonGridDtoPaginatedResults
 */
export interface ContactSiegeDoublonGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeDoublonGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContactSiegeDoublonGridDto>}
     * @memberof ContactSiegeDoublonGridDtoPaginatedResults
     */
    results?: Array<ContactSiegeDoublonGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContactSiegeDoublonGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContactSiegeDoublonGridDtoPaginatedResults interface.
 */
export function instanceOfContactSiegeDoublonGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeDoublonGridDtoPaginatedResultsFromJSON(json: any): ContactSiegeDoublonGridDtoPaginatedResults {
    return ContactSiegeDoublonGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContactSiegeDoublonGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeDoublonGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContactSiegeDoublonGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContactSiegeDoublonGridDtoPaginatedResultsToJSON(value?: ContactSiegeDoublonGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContactSiegeDoublonGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

